<template>
  <div v-if="propOrdensServico.length > 0"
       class="row mt-2">
    {{ propOs }}
    <div v-for="(os, index) in propOrdensServico"
         :key="`card_os_${index}`"
         :class="{'col-lg-4 col-md-12 mb-3': !viewList, 'col-lg-12 col-md-12 mb-3': viewList}">
      <div v-if="viewList"
           :class="statusSelos[verificandoStatusDosSelos (os)].icon === 'done'|| statusSelos[verificandoStatusDosSelos (os)].icon === 'clockTimeFour' ? 'OrdensServicoList_card' : 'corDosSelosNaoEnviados'">
        <div class="OrdensServicoList_header no-gutters row">
          <div class="OrdensServicoList_header--title col">
            <button class="btn btn-block w-100 text-left pt-2 pb-2"
                    @click="$emit('onEdit', {os, index})">
              <b>OS {{ os.numero }} - {{ os.created_at | date }}<b />
              <!--{{ selosItem(os) + '-' + selosEnviados(os) }}-->
              </b>
            </button>
          </div>
          <div class="OrdensServicoList_header--button col">
            <!--<button class="btn btn-sm mt-1"
                    v-if="selosItem(os) !== selosEnviados(os)"
                    @click="$emit('onEnviarSelo', os, index)"
                    v-b-tooltip.hover.top="'Enviar selos para TJ'">
              <icon-svg icon="fileUpload"
                        class="icon&#45;&#45;sm " />
            </button>-->
            <button v-if="os.sendingSelo"
                    v-b-tooltip.hover.top="'Selos Enviados para TJ'"
                    class="btn btn-sm mt-1">
              <b-spinner small
                         label="Spinning" />
            </button>
          </div>
          <!-- <div class="OrdensServicoList_header--button col mt-1">
            <button class="btn p-0 mt-1"
                    @click="$emit('onDelete', {os, index})">
              <icon-svg icon="trash"
                        class="icon-imprimir icons--red" />
            </button>
          </div>
          <div class="OrdensServicoList_header--button col mt-1 mx-2">
            <button class="btn p-0 mt-1"
                    @click="() => imprimirRecibo(os)">
              <icon-svg icon="print"
                        class="icon-imprimir" />
            </button>
          </div> -->

          <div class="OrdensServicoList_header--button col-1  mt-1 mx-2 d-flex justify-content-end">
            <div v-b-popover.bottomleft.hover.html="'<span>Opções</span>'"
                 class="popover-icon-dots-horizontal"
                 @click="ativandoMenuDeOpcoes(os.numero, 'exibir')">
              <icon-svg icon="dotsHorizontalCircle"
                        class="icon-dots-horizontal" />
            </div>
            <div :id="os.numero"
                 class="icon-dots-container-menu">
              <div class="icon-dots-menu-trash"
                   @click="$emit('onDelete', {os, index})">
                <icon-svg icon="trash"
                          class="icon-delete icons--red" />
              </div>
              <div class="icon-dots-menu-print"
                   @click="$emit('imprimirRecibo', os)">
                <icon-svg icon="print"
                          class="icon-imprimir" />
              </div>
            </div>
          </div>
        </div>
        <div :class="statusSelos[verificandoStatusDosSelos (os)].icon === 'close2' ? 'col-12 pt-2 pb-2 d-flex justify-content-between corDosSelosNaoEnviados': 'col-12 pt-2 pb-2 d-flex justify-content-between'">
          <div class="row">
            <div class="col">
              <label class="lbl">
                <u>Data OS</u>
              </label>
              <div>
                {{ os.created_at | date }}
              </div>
            </div>

            <div class="col">
              <label class="lbl row">
                <u>Valor Total</u>
              </label>
              <div>
                {{ os.valor_total | moneyToString }}
              </div>
            </div>
            <div :class="selosItem(os, false)?'col':'col'">
              <label class="lbl">
                <u>Selos</u>
              </label>
              <div class="text-left">
                {{ selosItem(os, false) }}
              </div>
            </div>
          </div>
          <div class="row align-self-end text-align-center">
            <div v-if="selosItem(os, true) > 0"
                 class="row mr-2">
              <div class="col">
                <label class="lbl">
                  <u>Selos Cancelados/Excluídos</u>
                </label>
                <div class="text-center">
                  {{ selosItem(os, true) }}
                </div>
              </div>
            </div>
            <div v-if="selosItem(os, false)"
                 class="col">
              <label class="lbl">
                <u>Status</u>
              </label>
              <div>
                <span v-b-popover.bottom.hover.html="`<span style='color:${statusSelos[verificandoStatusDosSelos (os)].color}'> ${condicaoParaExibirMsgDoPopover (os)}</span>`"
                      class="popover">
                  <IconSvg
                    :class="statusSelos[verificandoStatusDosSelos (os)].class"
                    :icon="statusSelos[verificandoStatusDosSelos (os)].icon" />
                </span>
              </div>
            </div>

            <div :class="selosItem(os, false)?'col':'col'">
              <label class="lbl row">
                <u>Data cumprida</u>
              </label>
              <div>
                {{ os.data_cumprida | date }}
              </div>
            </div>
          </div>
        </div>      
      </div>
      <div v-else
           :class="statusSelos[verificandoStatusDosSelos (os)].icon === 'done'|| statusSelos[verificandoStatusDosSelos (os)].icon === 'clockTimeFour' ? 'OrdensServicoList_card' : 'corDosSelosNaoEnviados'">
        <div class="OrdensServicoList_header row no-gutters">
          <div class="OrdensServicoList_header--title col-9">
            <button class="btn btn-block w-100 text-left pt-2 pb-2"
                    @click="$emit('onEdit', {os, index})">
              <b>OS {{ os.numero }} - {{ os.created_at | date }}<b />
              <!--{{ selosItem(os) + '-' + selosEnviados(os) }}-->
              </b>
            </button>
          </div>
          <div class="OrdensServicoList_header--button col">
            <!--<button class="btn btn-sm mt-1"
                    v-if="selosItem(os) !== selosEnviados(os)"
                    @click="$emit('onEnviarSelo', os, index)"
                    v-b-tooltip.hover.top="'Enviar selos para TJ'">
              <icon-svg icon="fileUpload"
                        class="icon&#45;&#45;sm " />
            </button>-->
            <button v-if="os.sendingSelo"
                    v-b-tooltip.hover.top="'Selos Enviados para TJ'"
                    class="btn btn-sm mt-1">
              <b-spinner small
                         label="Spinning" />
            </button>
          </div>
          <!-- <div class="OrdensServicoList_header--button col mt-1">
            <button class="btn p-0 mt-1"
                    @click="$emit('onDelete', {os, index})">
              <icon-svg icon="trash"
                        class="icon-imprimir icons--red" />
            </button>
          </div>
          <div class="OrdensServicoList_header--button col mt-1 mx-2">
            <button class="btn p-0 mt-1"
                    @click="() => imprimirRecibo(os)">
              <icon-svg icon="print"
                        class="icon-imprimir" />
            </button>
          </div> -->

          <div class="OrdensServicoList_header--button col mt-1 mx-2">
            <div v-b-popover.bottomleft.hover.html="'<span>Opções</span>'"
                 class="popover-icon-dots-horizontal"
                 @click="ativandoMenuDeOpcoes(os.numero, 'exibir')">
              <icon-svg icon="dotsHorizontalCircle"
                        class="icon-dots-horizontal" />
            </div>
            <div :id="os.numero"
                 class="icon-dots-container-menu">
              <div class="icon-dots-menu-trash"
                   @click="$emit('onDelete', {os, index})">
                <icon-svg icon="trash"
                          class="icon-delete icons--red" />
              </div>
              <div class="icon-dots-menu-print"
                   @click="$emit('imprimirRecibo', os)">
                <icon-svg icon="print"
                          class="icon-imprimir" />
              </div>
              <button
                v-if="podeEnviarSelos"
                class="icon-dots-menu-print w-100 border-0"
                :disabled="!podeEnviarSelos(os)"
                @click="$emit('enviarSelo', os)">
                <span>Enviar selo</span>
              </button>
            </div>
          </div>
        </div>
        
        <div :class="statusSelos[verificandoStatusDosSelos (os)].icon === 'close2' ? 'row p-2 pl-3 col-12 ml-0 corDosSelosNaoEnviados': 'row p-2 pl-3 col-12 ml-0'">
          <div class="col-6">
            <label class="lbl">
              <u>Data OS</u>
            </label>
            <div>
              {{ os.created_at | date }}
            </div>
          </div>

          <div :class="selosItem(os, false)?'col-6 pl-0':'col-6'">
            <label class="lbl">
              <u>Data cumprida</u>
            </label>
            <div>
              {{ os.data_cumprida | date }}
            </div>
          </div>
        </div>

        <div :class="statusSelos[verificandoStatusDosSelos (os)].icon === 'close2' ? 'row p-2 pl-3 col-12 ml-0 corDosSelosNaoEnviados': 'row p-2 pl-3 col-12 ml-0'">
          <div class="col-6">
            <label class="lbl">
              <u>Valor Total</u>
            </label>
            <div>
              {{ os.valor_total | moneyToString }}
            </div>
          </div>
          <div :class="selosItem(os, false)?'col-3 pl-0':'col-6'">
            <label class="lbl">
              <u>Selos</u>
            </label>
            <div class="text-left">
              {{ selosItem(os, false) }}
            </div>
          </div>
          <div v-if="selosItem(os, false)"
               class="col-3 pl-4">
            <label class="lbl">
              <u>Status</u>
            </label>
            <div>
              <span v-b-popover.bottom.hover.html="`<span style='color:${statusSelos[verificandoStatusDosSelos (os)].color}'> ${condicaoParaExibirMsgDoPopover (os)}</span>`"
                    class="popover">
                <IconSvg
                  :class="statusSelos[verificandoStatusDosSelos (os)].class"
                  :icon="statusSelos[verificandoStatusDosSelos (os)].icon" />
              </span>
            </div>
          </div>
        </div>
        <div v-if="selosItem(os, true) > 0"
             class="row p-2 pl-3 col-12">
          <div class="col-12">
            <label class="lbl">
              <u>Selos Cancelados/Excluídos</u>
            </label>
            <div class="text-left">
              {{ selosItem(os, true) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import custas from '@/constants/custas'
  import { useCaseOrdemServico } from "@/entities/OrdemServico/useCaseOrdemServico"


  export default {
    name: "OrdensServicoList",
    props: {
      propOrdensServico: { type: Array, default: () => []},
      propOs: { type: Number, default: null },
      propVisualizacao: {type: String, default: "card" },
      podeEnviarSelos: { type: Function, default: null }
    },
    data () {
      return {
        statusSelos: {
          'selo_enviado': {
            class: 'icon-done',
            icon: 'done',
            msg: 'Todos os selos enviados',
            color: '#008B27'
          },
          'selo_nao_enviado': {
            class: 'icon-close',
            icon: 'close2',
            msg: '',
            color: '#8B0000'
          },
          'aguardando': {
            class: 'icon-clock',
            icon: 'clockTimeFour',
            msg: 'Selos aguardando o envio',
            color: '#696969'
          }
        },  
        viewList: false,
        isFirstLoad: false
      }
    },
    watch: {
      '$route' () {
        // Verifica se é uma navegação de volta
        if (this.$route.name === 'ordem_servico_list') {
          location.reload() 
          this.isFirstLoad = true
        }
      },
      propOrdensServico () {
        if (this.propOrdensServico.length && this.propOs) {
          const index = this.propOrdensServico.findIndex(os => os.ordem_servico_id === this.propOs)

          if (index > -1) {
            this.$emit('onEdit', { os: this.propOrdensServico[index], index})
          }
        }
      },
      propVisualizacao () {
        this.propVisualizacao == "lista" ? this.viewList = true : this.viewList = false
      }
    },
    mounted () {
      window.addEventListener('popstate', function (event) {
        if (!this.isFirstLoad) {
          location.reload()
        }
        this.isFirstLoad = false // Atualiza a flag para indicar que não é mais a primeira carga
      })
    },

    created () {
      window.addEventListener('click', function (e) {
        const pegandoAsOs = document.querySelectorAll('.icon-dots-container-menu')
        const classesParaVerificacao = ['popover-icon-dots-horizontal', 'icon-dots-horizontal']
        const classeDoElementoClicado = e.target.parentElement.classList[0]

        if (!classesParaVerificacao.includes(classeDoElementoClicado)) {
          pegandoAsOs.forEach(os => {
            if (os.classList[1]) {
              os.classList.remove('mostrar-dropdown')
            }
          })
        }
      })
    },

    methods: {
      selosItem (os, canceladoOuExcluido = false) {
        let selosQtd = 0

        os.itens.forEach(ordemServico => {
          if (ordemServico.seloItemOs && ordemServico.seloItemOs.length > 0) {
            const selos = ordemServico.seloItemOs.filter(seloItemOs => {
              if (canceladoOuExcluido) {
                return seloItemOs.selo.cancelado_tj || seloItemOs.selo.excluido_tj
              }

              return !seloItemOs.selo.cancelado_tj && !seloItemOs.selo.excluido_tj
            })

            selosQtd += selos.length
          }
        })

        return selosQtd
      },

      selosPossiveis (os) {
        let selosPossiveis = 0

        os.itens.map(item => {
          if (custas.duplos.indexOf(item.custa.codigo) !== -1) {
            selosPossiveis = selosPossiveis + 2
          } else {
            selosPossiveis++
          }
        })

        return selosPossiveis
      },

      selosEnviados (os) {
        let selosEnviados = 0

        os.itens.map(item => {
          if (item.seloItemOs) {
            item.seloItemOs.map(async seloItem => {
              if (!!seloItem.selo.qrcode) {
                selosEnviados++
              }
            })
          }
        })

        return selosEnviados
      },

      ativandoMenuDeOpcoes (numeroDaOs, stringDaCondicao = 'naoExibir') {
        const opcaoClicada = document.getElementById(`${numeroDaOs}`)

        if (opcaoClicada) {
          if (stringDaCondicao === 'exibir') return opcaoClicada.classList.toggle('mostrar-dropdown')
          opcaoClicada.classList.remove('mostrar-dropdown')
        }
      },

      verificandoStatusDosSelos (os) {
        // Armazenando os status dos selos em um array.
        let quantidadeDeSelosNaOS = 0
        let statusSelos = []

        const arrayDosStatusDosSelos = os.itens.flatMap(item => {
          quantidadeDeSelosNaOS = item.seloItemOs.length
          statusSelos = item.seloItemOs.map(seloItem => seloItem.selo.status_selo)

          if (!quantidadeDeSelosNaOS) return 'custa_sem_selo'
          return item.seloItemOs.map(dadosDoSelo => dadosDoSelo.selo.envio_tj)
        })

        // Condições para identificar o status do selo.

        // Selo enviado:
        if (arrayDosStatusDosSelos.every(status => status === 1 || status === 'custa_sem_selo')) {
          return 'selo_enviado'
        }
        // Selo Pendente:
        else if ((arrayDosStatusDosSelos.indexOf(0) != -1) && (statusSelos.indexOf('PENDENTE') != -1)) {
          return 'aguardando'
        }
        // Selo com erro:
        else {
          return 'selo_nao_enviado'
        }

        // Condições antigas:
        // else if (arrayDosStatusDosSelos.every(status => status === 0) && statusSelos.every(statusSelo => statusSelo === 'PENDENTE')) {
        //   return 'aguardando'
        // }
        // else if (arrayDosStatusDosSelos.every(status => status === 0 || status === 'custa_sem_selo'))  {
        //   return 'selo_nao_enviado'
        // }

      },

      condicaoParaExibirMsgDoPopover (os) {
        return this.statusSelos[this.verificandoStatusDosSelos (os)].icon === 'close2' ? `${this.statusSelos['selo_nao_enviado'].msg = `${this.selosItem(os) > 1 ? `${this.selosItem(os)} selos não enviados ao TJ` : `${this.selosItem(os)} selo não enviado ao TJ`}`}` : this.statusSelos[this.verificandoStatusDosSelos (os)].msg
      },

      imprimirRecibo (os) {
        new useCaseOrdemServico(os).imprimirRecibo()
      }
    }
  }
</script>

<style scoped lang="scss">

  .lbl {
    font-weight: 500;
    margin-bottom: 0;
    cursor: default;
  }


  .corDosSelosNaoEnviados {
    background-color: #EEB5BD;
  }

  .OrdensServicoList {
    &_card {
      box-shadow: 2px 2px 4px #00000029;
    }

    &_header {
      background-color: #C6C6C6;
      border-radius: 2px 2px 0 0;

      &--title{
        float: left;
        font-size: 18px;
        font-weight: 500;
      }

      &--button{
        text-align: right;
      }
    }
  }
  .icon-delete {
    height: 20px;
    width: 20px;
    padding: 0px;
  }
  .icon-imprimir {
    height: 20px;
    width: 20px;
    padding: 0px;
  }
  .popover-icon-dots-horizontal {
    width: 50px;
    margin-top: 5px;
    padding-right: 5px;
    position: relative;
  }
  .icon-dots-horizontal {
    height: 25px;
    width: 30px;
    padding: 0px;
  }
  .icon-dots-container-menu  {
    background-color: #ffffff;
    text-align: center;
    position: absolute;
    width: 100px;
    z-index: 1;
    left: 50px;
    border-radius: 3px;
    box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, 0.2);
    display: none;
  }

  .icon-dots-menu-trash::after {
    content: "";
	  width: 0;
	  height: 0;
	  position: absolute;
	  border-left: 20px solid transparent;
	  border-right: 20px solid transparent;
	  border-top: 20px solid #ffffff;
    transform: rotate(20deg);
	  top: 2px;
	  left: -10%;
  }
  .icon-dots-menu-trash:hover::after {
	  border-top: 20px solid #69aadb;
  }

  .icon-dots-menu-trash:hover {
    background-color: #69aadb;
    color:#ffffff;
    cursor: pointer;
  }

  .icon-dots-menu-print {
    background-color: #ffffff;
    padding-bottom: 2px;
    border-radius: 3px;
  }
  .icon-dots-menu-print:hover {
    background-color: #69aadb;
    color:#ffffff;
    cursor: pointer;
  }

  .mostrar-dropdown {
    display: block;
  }

  .icon-done {
    fill: #008b27;
    width: 25px;
    height: 30px;
  }

  .icon-close {
    fill: #8b0000;
    width: 25px;
    height: 30px;
    background-color: #EEB5BD;
  }

  .icon-clock {
    color: #696969;
    width: 25px;
    height: 30px;
  }

  .popover {
    background-color: #ffffff;
    border: none;
    margin-top: 20px;
    margin-left: 24px;
    padding-left: 0;
    z-index: 0;
  }
</style>
